import Spinner from 'components/Spinner';
import { number } from 'prop-types';
import styled from 'styled-components';
const StyledLoading = styled.div`
   align-items: center;
   border-radius: 12px;
   cursor: progress;
   display: flex;
   height: 200px;
   justify-content: center;
   width: 100%;
`;
const Loading = ({ colSpan = 1 }) => (
   <tr>
      <td colSpan={colSpan}>
         <StyledLoading>
            <Spinner />
         </StyledLoading>
      </td>
   </tr>
);
Loading.propTypes = { colSpan: number };
export default Loading;
